import '../styles/nav.css';
import logo_1 from '../imgs/logo_1.png';
import { NavLink } from 'react-router-dom';
import { useEffect, useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faMoon, faSun } from '@fortawesome/free-solid-svg-icons';

const getInitialTheme = () => {
    const savedTheme = window.localStorage.getItem('eosrmg-theme');
    if (savedTheme === 'light' || savedTheme === 'dark') return savedTheme;
    return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
};

export default function Navbar() {
    const [isScrolled, setIsScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [theme, setTheme] = useState(getInitialTheme);

    useEffect(() => {
        const root = document.documentElement;
        const themeColor = document.querySelector('meta[name="theme-color"]');
        root.dataset.theme = theme;
        root.style.colorScheme = theme;
        if (themeColor) themeColor.setAttribute('content', theme === 'light' ? '#f4f7fb' : '#0a0a10');
    }, [theme]);

    useEffect(() => {
        const media = window.matchMedia('(prefers-color-scheme: light)');
        const syncWithSystem = (event) => {
            if (!window.localStorage.getItem('eosrmg-theme')) {
                setTheme(event.matches ? 'light' : 'dark');
            }
        };
        media.addEventListener('change', syncWithSystem);
        return () => media.removeEventListener('change', syncWithSystem);
    }, []);

    useEffect(() => {
        let timeoutId = null;
        const handleScroll = () => {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                setIsScrolled(window.scrollY > 20);
            }, 10);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, []);

    useEffect(() => {
        if (!menuOpen) return undefined;
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') setMenuOpen(false);
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [menuOpen]);

    const closeMenu = useCallback(() => setMenuOpen(false), []);
    const toggleTheme = () => {
        const nextTheme = theme === 'dark' ? 'light' : 'dark';
        window.localStorage.setItem('eosrmg-theme', nextTheme);
        setTheme(nextTheme);
    };

    return (
        <>
            <nav className={`nav ${isScrolled ? 'nav-scrolled' : ''}`}>
                <div className="nav-inner">
                    <NavLink to="/" className="logo" aria-label="EosRmg home">
                        <img src={logo_1} alt="EosRmg Logo" width="100" height="100" />
                        <span className="logo-name">eos<span className="logo-name--accent">Rmg</span></span>
                    </NavLink>
                    <button
                        className="hamburger"
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="Toggle menu"
                        aria-expanded={menuOpen}
                    >
                        <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
                    </button>
                    <ul className="nav-links nav-links--desktop">
                        <li><NavLink to="/">Home</NavLink></li>
                        <li><NavLink to="/apps">Apps</NavLink></li>
                        <li><NavLink to="/contact">Contact</NavLink></li>
                    </ul>
                    <button
                        className="theme-toggle theme-toggle--mobile"
                        onClick={toggleTheme}
                        aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
                        title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
                    >
                        <FontAwesomeIcon icon={theme === 'dark' ? faSun : faMoon} />
                    </button>
                </div>
            </nav>

            <button
                className="theme-toggle theme-toggle--desktop"
                onClick={toggleTheme}
                aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
                title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
            >
                <FontAwesomeIcon icon={theme === 'dark' ? faSun : faMoon} />
            </button>

            <div
                className={`mobile-menu ${menuOpen ? 'mobile-menu--open' : ''}`}
                onClick={closeMenu}
                aria-hidden={!menuOpen}
            >
                <ul className="mobile-menu__links" onClick={(event) => event.stopPropagation()}>
                    <li><NavLink to="/" onClick={closeMenu}>Home</NavLink></li>
                    <li><NavLink to="/apps" onClick={closeMenu}>Apps</NavLink></li>
                    <li><NavLink to="/contact" onClick={closeMenu}>Contact</NavLink></li>
                </ul>
            </div>
        </>
    );
}
